import { render, staticRenderFns } from "./XwzxForView.vue?vue&type=template&id=a3d4ec6e&"
import script from "./XwzxForView.vue?vue&type=script&lang=js&"
export * from "./XwzxForView.vue?vue&type=script&lang=js&"
import style0 from "./XwzxForView.vue?vue&type=style&index=0&id=a3d4ec6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports